import { Suspense, useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import Loader from "../loader/Loader";

type icon = {
  icon: string;
  className?: string;
  onClick?: any;
  style?: any;
};

export default function Icon(props: icon) {
  const [receivedLogo, setReceivedLogo] = useState();

  const usedStyle = props.className ? props.className : "icon-white-2";

  useEffect(() => {
    (async () => {
      try {
        if (props.icon) {
          const { default: image } = await import(
            `../../images/${props.icon}.svg`
          );

          setReceivedLogo(image);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, [props]);

  return (
    <Suspense fallback={<Loader pageTitle="Applicatie laden" />}>
      <Image
        src={receivedLogo}
        style={props.style}
        draggable="false"
        onClick={props?.onClick}
        className={usedStyle}
      />
    </Suspense>
  );
}
